<template>
  <div class="time text-center text-text-muted" :title="getRealTime()">
    <slot></slot>{{getRelativeTime}}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';

const props = defineProps({
  time: [String, Number, Object],
});

const store = useStore();
const { t } = useI18n();

const nowUTC = computed(() => store.state.system.nowUTC);

const getRelativeTime = computed(() => {
  let result = '';
  if (nowUTC.value) {
    if (nowUTC.value.diff(props.time, 'seconds') < 20) {
      result = t('task.just_now');
    } else if (nowUTC.value.diff(props.time, 'seconds') < 60) {
      result = `${Math.floor(nowUTC.value.diff(props.time, 'seconds') / 10)}0${t('time.S')}`;
    } else if (nowUTC.value.diff(props.time, 'seconds') < 3600) {
      result = `${nowUTC.value.diff(props.time, 'minutes')}${t('time.M')}`;
    } else if (nowUTC.value.diff(props.time, 'hours') < 24) {
      const hours = nowUTC.value.diff(props.time, 'hours');
      const minutes = nowUTC.value.diff(props.time, 'minutes') - hours * 60;
      result = `${hours}${t('time.H')} ${minutes}${t('time.M')}`;
    } else if (nowUTC.value.diff(props.time, 'days') < 7) {
      result = `${nowUTC.value.diff(props.time, 'days')}${t('time.d')}`;
    } else if (nowUTC.value.diff(props.time, 'days') < 365) {
      result = `${nowUTC.value.diff(props.time, 'weeks')}${t('time.w')}`;
    } else {
      result = `${nowUTC.value.diff(props.time, 'years')}${t('time.y')}`;
    }
  }
  return result.toLowerCase();
});

const getRealTime = () => dayjs(props.time).format('HH:mm:ss MMM D, YYYY');
</script>
